module.exports = __webpack_public_path__ + "img/cyberpunk-city.ed3efa91.webp";